var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main"}},[_c('div',{staticStyle:{"position":"relative","width":"100%"}},[_c('TopNav'),_c('div',{attrs:{"id":"panels"}},[_c('div',{staticClass:"xscroll"},[_c('Panel1'),_c('Panel2')],1),_c('Footer')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }